import { render, staticRenderFns } from "./ProjectChangeOrder.vue?vue&type=template&id=33d051a6"
import script from "./ProjectChangeOrder.vue?vue&type=script&lang=js"
export * from "./ProjectChangeOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports